// Module
var code = "\n";
// Exports
module.exports = code;